/**
 * A mensagem que o backend mandou num erro do Insights, ou `fallback`.
 *
 * O backend responde em dois formatos. O middleware devolve o erro no topo
 * (`{ name, message }`); o erro lançado por um handler passa pelo tratador
 * global do `app.ts` e chega embrulhado (`{ statusCode, data: { name, message } }`).
 * Ler só o primeiro trocava toda recusa de handler (por exemplo o 403 de
 * "Todos os contratos" para quem não é corretora, backend #2086) pelo texto
 * genérico.
 *
 * Fora de `insights.service.ts` para ser testável: aquele módulo usa
 * `import.meta.env`, que o jest deste repositório não carrega.
 */
export function getInsightsErrorMessage(error: any, fallback: string): string {
  const body = error?.response?.data;
  const message = body?.message ?? body?.data?.message;
  return typeof message === "string" && message.trim() ? message : fallback;
}
